import { Component, computed, input, model, WritableSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ShopCategory } from '../../models/items.model';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-categories-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatMenuModule, MatDividerModule, MatButtonModule],
  templateUrl: './categories-menu.component.html',
  styleUrl: './categories-menu.component.scss',
})
export class CategoriesMenuComponent {
  shopCategories = input.required<ShopCategory[]>();
  shopCategoriesCount = computed(() => this.shopCategories().filter((x) => x.isLeaf()).length);
  topShopCategories = computed(() => {
    return this.shopCategories().filter((category) => !category.parentCategory);
  });
  selectedCategories = model.required<Set<ShopCategory>>();

  selectAllSubCats(categoryFromDisplay: ShopCategory) {
    const addAllSubCats = (cat: ShopCategory, cats: Set<ShopCategory>) => {
      cat.subCategories.forEach((subCat) => {
        if (this.shopCategories().includes(subCat)) {
          if (subCat.isLeaf()) cats.add(subCat);
          addAllSubCats(subCat, cats);
        }
      });
    };

    this.selectedCategories.update((cats) => {
      const newCats = new Set(cats);
      addAllSubCats(categoryFromDisplay, newCats);
      return newCats;
    });
  }

  removeAllSubCats(categoryFromDisplay: ShopCategory) {
    const removeAllSubCatsRecursive = (cat: ShopCategory, cats: Set<ShopCategory>) => {
      cat.subCategories.forEach((subCat) => {
        if (this.shopCategories().includes(subCat)) {
          if (subCat.isLeaf()) cats.delete(subCat);
          removeAllSubCatsRecursive(subCat, cats);
        }
      });
    };

    this.selectedCategories.update((cats) => {
      const newCats = new Set(cats);
      removeAllSubCatsRecursive(categoryFromDisplay, newCats);
      return newCats;
    });
  }

  toggleCategorySelection(categoryFromDisplay: ShopCategory): void {
    this.selectedCategories.update((cats) => {
      const newCats = new Set(cats);
      if (newCats.has(categoryFromDisplay)) {
        newCats.delete(categoryFromDisplay);
      } else {
        newCats.add(categoryFromDisplay);
      }
      return newCats;
    });
  }

  clearSelection(): void {
    this.selectedCategories.set(new Set<ShopCategory>());
  }

  isCategorySelected(categoryFromDisplay: ShopCategory): boolean {
    return this.selectedCategories().has(categoryFromDisplay);
  }

  filterSubCategories(categoryFromDisplay: ShopCategory): ShopCategory[] {
    return categoryFromDisplay.subCategories.filter((subCat) => this.shopCategories().flat().includes(subCat));
  }
}
